<template>
  <div class="container">
    <div class="title">
      <span @click="$router.go(-1)" style="cursor: pointer">规则列表</span>
      /
      <span v-if="type===1">新增</span>
      <span v-if="type===2">查看</span>
      <span v-if="type===3">修改</span>

    </div>
    <div class="content">
      <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="编号规则名称" prop="name">
          <a-input v-model="form.name"/>
        </a-form-model-item>
        <a-form-model-item ref="list" label="编号规则" prop="list">
          <!--          <a-input v-model="createform.name" v-for="(item,index) in createform.list" :key="index"/>-->
          <div class="table-wrapper">
            <table>
              <tr>
                <th class="line1">柜体分类</th>
                <th class="line2">编号前缀</th>
              </tr>
              <tr
                  v-for="(item,index) in form.reqs" :key="index"
              >
                <th  class="line1">{{item.type}}</th>
                <th  class="line2"><a-input v-model="item.prefix"></a-input></th>

              </tr>
            </table>
          </div>
        </a-form-model-item>
      </a-form-model>
      <div class="btn" v-if="type===2">
        <a-button style="width: 100px" type="primary" @click="cancle">返回</a-button>
      </div>
      <div class="btn" v-else>
        <a-button style="width: 100px;margin-right: 20px" type="primary" @click="submit">确定</a-button>
        <a-button style="width: 100px" @click="cancle">取消</a-button>
      </div>
    </div>
  </div>
</template>

<script>
// import mockData from "@/mock/mock";
import {createRule, ruleDetail,editRule} from "@/api/rule";
export default {
  name: "CreateRule",
  data(){
    return {
      // info:mockData,
      userId:'3FO4J7X19MT8',
      id:'',
      type:1,
      form:{
        name:'',
        reqs:[
        ]
      },
      rules:{
        name:[{ required: true, message: '请输入规则名称', trigger: 'blur' },]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    }
  },
  mounted() {
    // this.info= mockData
    if(this.$route.query.type==='create'){
      this.type = 1
      this.getGui()
    }else if(this.$route.query.type==='look'){
      this.type = 2
      this.getDetail(this.$route.query.id)
    }else if(this.$route.query.type==='change'){
      this.type = 3
      this.getDetail(this.$route.query.id)
    }
  },
  methods:{
    async getDetail(id){
      console.log(id,'id');
      const data = await ruleDetail({id:id})
      console.log(data,'detail');
      this.form =data.data
      this.form.reqs = data.data.vos
      // this.form = {
      //   name:'测试',
      //   list:[
      //     {
      //       name:'测试',
      //       content:'123'
      //     }
      //   ]
      // }
    },
    getGui(){
      let list = []
      // this.info.data.paramModel.forEach(item=>{
      //   if(item.customCode){
      //     list.push(item.customCode)
      //   }
      // })
      // list = Array.from(new Set(list))
      // this.form.reqs = list.map(item=>{
      //   let xx = {}
      //   xx.type = item
      //   xx.prefix = ''
      //   return xx
      // })

      console.log(this.form.reqs,'list');
    },
    async submit(){
      console.log(this.form,'form');
      if(this.form.name==''){
        return this.$message.error('请输入编号规则名称')
      }
      if(this.type===1){
        const data = await createRule({
          ...this.form,
        })
        if(data.code===200){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }else{
          this.$message.error(data.message)
        }
      }else if(this.type===3){
        let params = {
          id:this.form.id,
          name:this.form.name,
          reqs:this.form.reqs.map(item=>{
            return {type:item.type,prefix:item.prefix}
          })
        }
        const data = await editRule({
          ...params,
        })
        if(data.code===200){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }else{
          this.$message.error(data.message)
        }
      }

    },
    cancle(){
      this.$router.go(-1)
    },
  },
  beforeDestroy() {
    this.form = {
      name:'',
      list:[]
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  text-align: left;
  .title{
    padding:4px 10px;
    background: #1ea8ff;
    color: white;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .content{

  }
  .btn{
    text-align: center;

  }
  .line1{
    min-width: 80px;
  }
  .line2{
    flex: 1;
  }
  .table-wrapper{
  }
  table{
    width: 100%;
  }
  table, th, td
  {
    border: 1px solid #d9d9d9;
    padding: 0 10px;

  }
}
</style>
